import type { GroupTiming, ResolvedTask } from './blueprint/types';
import type { Phase } from './derive-phase';

export type PhaseProgress = {
  phase: Phase;
  done: number;
  total: number;
};

// Order used in the segmented progress bar (chronological).
export const PHASE_PROGRESS_ORDER: Exclude<Phase, 'Unknown'>[] = [
  'EarlyPlanning',
  'CoreBooking',
  'DetailPlanning',
  'FinalCountdown',
  'DayAndAfter',
];

/**
 * Done and total tasks per phase over the couple's own checklist. Each task goes in the
 * phase of its group. Only the couple's tasks count, not the whole template.
 */
export const computePhaseProgress = (
  tasks: readonly ResolvedTask[],
  timings: Map<string, GroupTiming>,
): PhaseProgress[] => {
  const counts: Record<Exclude<Phase, 'Unknown'>, { done: number; total: number }> = {
    EarlyPlanning: { done: 0, total: 0 },
    CoreBooking: { done: 0, total: 0 },
    DetailPlanning: { done: 0, total: 0 },
    FinalCountdown: { done: 0, total: 0 },
    DayAndAfter: { done: 0, total: 0 },
  };

  for (const task of tasks) {
    const phase = timings.get(task.group)?.phase;
    if (!phase || phase === 'Unknown') {
      continue;
    }
    counts[phase].total += 1;
    if (task.done) {
      counts[phase].done += 1;
    }
  }

  return PHASE_PROGRESS_ORDER.map((phase) => ({
    phase,
    done: counts[phase].done,
    total: counts[phase].total,
  }));
};
